import { JSX, useState } from 'react';
import { NoteProps } from '../note/note';
import NoteContent from '../note/noteContent';
import './noteView.css';
import NoteManager from '../todolist/data/noteManager';
import AddButton from '../common/AddButton/addButton';
import { processNoteApi } from '../services/process-notes';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import Loading from '../common/Loading/loading';
import NoteTodos from '../note-page/note-todos';
import TodoManager from '../todolist/data/todoManager';

const NoteView = ({ note, updateNoteContent }: { note: NoteProps, updateNoteContent: (content: string) => void }): JSX.Element => {
    const [isNoteEdit, setIsNoteEdit] = useState(false);
    const [isReprocess, setIsReprocess] = useState(false);
    const [todos, setTodos] = useState<TodoTask[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const noteManager = NoteManager.getInstance();
    const todoManager = TodoManager.getInstance();
    const updateNoteDate = async (date: Date) => {
        try {
            setIsLoading(true);
            await noteManager.updateNoteDate(note, date);
            setIsLoading(false);
        } catch (error) {
            console.error('Failed to update note:', error);
        }
    }

    const saveNote = async () => {
        try {
            setIsLoading(true);
            await noteManager.updateNoteContent(note, note.content);
            setIsLoading(false);
        } catch (error) {
            console.error('Failed to update note:', error);
        }

        setIsNoteEdit(false)
    }

    const reprocessNote = async () => {
        processNote();
        setIsReprocess(true);
    }

    const processNote = async () => {
        try {
            setIsLoading(true);
            const newtodos = await processNoteApi.extractTodosFromNotes(note);
            console.log(newtodos);
            setTodos(newtodos.todos);
            setIsLoading(false);
        } catch (error) {
            console.error('Failed to update note:', error);
        }
    }

    const editTitle = (todo: TodoTask, newTitle: string) => {
        setTodos(todos.map(t => t.id === todo.id ? {...t, title: newTitle} : t));
    }

    const deleteTodo = (todo: TodoTask) => {
        setTodos(todos.filter(t => t.id !== todo.id));
    }

    const addTodo = (todo: TodoTask) => {
        setTodos([...todos, todo]);
    }
    
    const addNewTodo = async () => {
        setIsLoading(true);
        todos.forEach(async (todo) => {
            await todoManager.addTodo(todo);
        });
        setTodos([]);
        setIsLoading(false);
    }

    return (
        <div className='note-view-container'>
            <p className='note-view-title'>{note.title}</p>
            <NoteContent noteContent={note.content} noteDate={note.date} onContentChange={(content: string) => updateNoteContent(content)} onDateChange={(date: Date) => updateNoteDate(date)} onFocus={() => setIsNoteEdit(true)} editMode={isNoteEdit}/>
            
            {isNoteEdit? (
                <div className='note-view-content'>
                    {isReprocess? (
                        <div>
                            <NoteTodos note={note} todos={todos} editTitle={editTitle} deleteTodo={deleteTodo} saveTodo={addTodo}/> 
                            <AddButton title='Add' addFunction={addNewTodo}/>
                        </div>
                    ) : (<></>)}
                    <div className='note-view-buttons'>
                        <AddButton title='Reprocess' addFunction={reprocessNote}/>
                        <AddButton title='Save' addFunction={saveNote}/>
                    </div>
                </div>
            ) : (<></>)}
            {isLoading? (<Loading/>):(<></>)}
        </div>
    );
}

export default NoteView;